export const environment = {
  production: false,
  backendBaseUrl:
    'https://analyst-selectiontool.apps.acc.compumark.com/analyst-selection-tool-api',
  license: {
    agGrid:
      'Using_this_{AG_Grid}_Enterprise_key_{AG-101917}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Clarivate_Analytics_(US)_LLC}_is_granted_a_{Multiple_Applications}_Developer_License_for_{5}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{2}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{16_July_2027}____[v3]_[01]_MTgxNTY5MjQwMDAwMA==e1f56c5b3a302fe6534c58d242fd7b1c',
  },
  analytics: {
    enabled: true,
    pendo: {
      apiKey: '509e59f8-39d8-466a-78e8-e35df26e1226',
    },
    oneTrust: {
      apiKey: '01903488-ed62-7b0b-8c4e-6ecfd7ac9654',
      productionUrl: 'analyst-selection-tool-ui.apps.compumark.com',
    },
  },
  features: {
    previewShowPocaCount: true,
  },
};
